import createHistory from './application/history';
import createStore from './redux/store';

const history = createHistory();
const store = createStore(history)();

export { store };
export { history };
